module.exports = __webpack_public_path__ + "static/media/response-contact.1400b6b8.svg";